import React from 'react';
import {useSelector} from 'react-redux';
import {Select, MenuItem} from '@material-ui/core';
import {selectRatings} from './Redux/ratingSelectors';
import './ratingSelect.scss';

export interface RatingSelectProps {
    value: string;
    onChange: (val: string) => void;
}

export const mapToMenuItem = (value: string) => {
    return (
        <MenuItem value={value} key={value}>
            {value}
        </MenuItem>
    )
}

export const RatingSelect = (props: any) => {
    const {
        value,
        onChange,
    } = props;
    const ratings = useSelector(selectRatings);

    return (
        <Select
            className="ratings-select"
            value={value}
            onChange={onChange}
            variant="filled"
        >
            {Object.keys(ratings).map(mapToMenuItem)}
        </Select>
    );
};
